<template>
  <div class="get-started-template" />
</template>

<script>
import _ from "lodash";
import VueCookie from "vue-cookie";

export default {
  name: "PreviewGetStarted",
  computed: {
    isPrivateJournal() {
      return this.previewData.careplan && this.previewData.careplan.type;
    },
    type() {
      return this.$route.query.type;
    },
    code() {
      return this.$route.query.code;
    },
    previewData() {
      return this.$store.state.base.preview;
    },
    userType() {
      return this.$store.state.user.info.user_type;
    },
    getOS() {
      let userAgent = (userAgent = window.navigator.userAgent),
        platform = window.navigator.platform,
        macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
        windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
        iosPlatforms = ["iPhone", "iPad", "iPod"],
        os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = "Mac OS";
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = "Windows";
      } else if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
      }

      return os;
    }
  },
  async mounted() {
    await this.getPrescription();
    this.getStarted();
  },
  methods: {
    async getPrescription() {
      if (this.code) {
        try {
          let res = await this.$store.dispatch("base/getPrescription", {
            code: this.code,
            type: this.type
          });
        } catch (e) {
          console.log(e);
        }
      }
    },
    getStarted() {
      VueCookie.set(
        "PRESCRIPTION_PRESCRIBED_BY",
        this.previewData.prescribed_by
      );
      if (this.previewData.comment)
        VueCookie.set("PRESCRIPTION_MOBILE", this.previewData.comment);
      VueCookie.set("PRESCRIPTION_CODE", this.code);
      if (this.isPrivateJournal === "private_journal")
        VueCookie.set("PRESCRIPTION_CODE_TYPE", this.isPrivateJournal);
      if (this.previewData.careplan_id)
        VueCookie.set("PRESCRIPTION_GROUP", this.previewData.careplan_id);
      if (_.get(this.previewData, "user_story.id"))
        VueCookie.set("PRESCRIPTION_USER_STORY", this.previewData.user_story.id);

      this.getOS === "Mac OS" || this.getOS === "iOS"
        ? this.getStartedMac()
        : this.getStartedWindows();
    },
    async getStartedMac() {
      let mCookie = localStorage.getItem(
        Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + "COOKIE"
      );
      let uCookie = JSON.parse(mCookie);

      if (VueCookie.get("os_type") === "ios") {
        // in app
        if (uCookie && this.userType === "member") {
          if (_.get(this.previewData, "careplan.type") == "add-ons") {
            this.$router.replace({
              path: `/${this.$route.params.brandSlug}/home`,
              query: {
                group_invite_code: this.code
              }
            });
          } else if (
            _.get(this.previewData, "careplan.type") == "private_journal"
          ) {
            this.$router.replace({
              path: `/${this.$route.params.brandSlug}/home`,
              query: {
                care_team_request_code: this.code
              }
            });
          } else {
            if (_.get(this.previewData, "is_accepted")) {
              this.$router.replace({
                path: `/${this.$route.params.brandSlug}/home`
              });
            } else {
              await this.$store.dispatch(
                "base/onRegisterUserStory",
                {
                  userStory: this.previewData.careplan_id,
                  slug: this.$route.params.brandSlug
                },
                { root: 1 }
              );
            }
          }
        } else {
          this.$router.replace(`/${this.$route.params.brandSlug}/login?type=signup`);
        }
      } else {
        // in web
        if (uCookie && this.userType === "member") {
          if (_.get(this.previewData, "careplan.type") == "add-ons") {
            let redirect = await this.$store.dispatch("base/getRedirectLink", {
              url: `${process.env.VUE_APP_SITE}${this.$route.params.brandSlug}/home?group_invite_code=${this.code}`
            });
            window.location.replace(redirect.data.url);
          } else if (
            _.get(this.previewData, "careplan.type") == "private_journal"
          ) {
            let redirect = await this.$store.dispatch("base/getRedirectLink", {
              url: `${process.env.VUE_APP_SITE}${this.$route.params.brandSlug}/home?care_team_request_code=${this.code}`
            });
            window.location.replace(redirect.data.url);
          } else {
            if (_.get(this.previewData, "is_accepted")) {
              let redirect = await this.$store.dispatch("base/getRedirectLink", {
                url: `${process.env.VUE_APP_SITE}${this.$route.params.brandSlug}/home`
              });
              window.location.replace(redirect.data.url);
            } else {
              await this.$store.dispatch(
                "base/onRegisterUserStory",
                {
                  userStory: this.previewData.careplan_id,
                  slug: this.$route.params.brandSlug
                },
                { root: 1 }
              );
            }
          }
        } else {
          let redirect = await this.$store.dispatch("base/getRedirectLink", {
            url: `${process.env.VUE_APP_SITE}${this.$route.params.brandSlug}/login?type=signup`
          });
          window.location.replace(redirect.data.url);
        }
      }
    },
    async getStartedWindows() {
      let mCookie = localStorage.getItem(
        Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + "COOKIE"
      );
      let uCookie = JSON.parse(mCookie);
      if (uCookie && this.userType === "member") {
        this.isLoading = true;

        if (_.get(this.previewData, "careplan.type") == "add-ons") {
          this.$router.replace({
            path: `/${this.$route.params.brandSlug}/home`,
            query: {
              group_invite_code: this.code
            }
          });
        } else if (
          _.get(this.previewData, "careplan.type") == "private_journal"
        ) {
          this.$router.replace({
            path: `/${this.$route.params.brandSlug}/home`,
            query: {
              care_team_request_code: this.code
            }
          });
        } else {
          if (_.get(this.previewData, "is_accepted")) {
            this.$router.replace({
              path: `/${this.$route.params.brandSlug}/home`
            });
          } else {
            await this.$store.dispatch(
              "base/onRegisterUserStory",
              {
                userStory: this.previewData.careplan_id,
                slug: this.$route.params.brandSlug
              },
              { root: 1 }
            );
          }
        }

        this.isLoading = false;
        return;
      } else {
        if (
          VueCookie.get("os_type") === "ios" &&
          !VueCookie.get("ios_app_version")
        ) {
          window.webkit.messageHandlers.onNativeCalled.postMessage({
            name: "authRegister",
            params: {}
          });
          return false;
        }

        this.$router.replace({
          path: `/${this.$route.params.brandSlug}/login?type=signup`
        });
        return;
      }
    }
  }
};
</script>

<style scoped>
.get-started-template {
  background: url("~@/assets/main.gif") no-repeat fixed center;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
</style>
